import React from "react";
import { Link } from "react-router-dom";

class Drawertwo extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {};
  }
  render() {
    return (
      <div className="menu-style">
        <div className="drawertwo">
          <ul className="my-list">
            {this.props.MenuListDatafour.map((i) => {
              return (
                <Link
                  to={`/errorCodeList/${i.id},${this.props.language},${this.props.buId},${this.props.type}`}
                  key={i.id}
                >
                  <li>
                    <div className="list-cont ">{i.name}</div>
                  </li>
                </Link>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Drawertwo;



// WEBPACK FOOTER //
// ./src/pages/Home/Drawertwo.js